import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { SupportEmail } from "../core/CommonLinks";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import { useQueryClient } from "@tanstack/react-query";
import { useLogout } from "@seabrookstudios/auth-web";
import { enqueueSnackbar } from "notistack";
import { useCloseAccount } from "@seabrookstudios/pitch2table";

export const CloseAccount = () => {
  const queryClient = useQueryClient();
  const logout = useLogout();

  const onSuccess = () => {};
  const onFailure = () => {
    enqueueSnackbar("Unable to close account. Please contact support", { variant: "error" });
  };

  const closeAccount = useCloseAccount(onSuccess, onFailure);

  const closeAccountFlow = async () => {
    await closeAccount.mutateAsync();
    queryClient.invalidateQueries();
    await logout();
  };

  const onCloseAccount = async () => {
    if (window.confirm("Confirm account closure?")) {
      await closeAccountFlow();
      return;
    }
  };

  return (
    <Card elevation={1} square={false}>
      <CardHeader title="Close Account" />
      <CardContent>
        <Typography>
          If you don't want to use pitch2table any more, you can close your account using the button below.
        </Typography>
        <Box padding={1} />
        <Typography>
          We will retain your data for 90 days post closure in case you wish to restore your account. If you wish to
          reduce this time period or reinstate your account, please: <SupportEmail />.
        </Typography>
        <Box padding={1} />
        <Typography>
          Any data uploaded to co-designs will remain and your co-designer will have access to it.
        </Typography>
        <Box padding={1} />
        <Typography>After 90 days it will not be possible to recover your account data.</Typography>
      </CardContent>
      <CardActions>
        <Button variant="contained" onClick={onCloseAccount}>
          Close Account
        </Button>
      </CardActions>
    </Card>
  );
};
